import { types } from 'mobx-state-tree';

import { PassolutionEndpoints } from './types/endpoints';
import { EntryConditions } from './types/entry-conditions';
import { PassolutionOptions } from './types/options';
import { PassolutionSelection } from './types/selection';

export const PassolutionStore = types.model('PassolutionStore', {
  endpoints: types.optional(PassolutionEndpoints, {}),
  entryConditions: EntryConditions,
  options: types.optional(PassolutionOptions, {}),
  selection: types.optional(PassolutionSelection, {}),
});

export const initialState = {};
